import React, { useState } from 'react';
import '../App.css'; // Assuming the styles will be in App.css

const Explorer = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [iframeSrc, setIframeSrc] = useState('https://baitexplorer.bait-coin.com');

  // Function to handle search
  const handleSearch = () => {
    if (searchQuery.trim()) {
      setIframeSrc(`https://baitcoinexplorer.bait-coin.com/?search=${searchQuery.trim()}`);
    }
  };
  
  return (
    <div className="explorer-container">
      <div className="explorer-header">
        <h1>Bait Coin Block Explorer</h1>
        <p>Explore the Bait Coin blockchain by entering a transaction or block ID.</p>
      </div>
      
      <div className="search-box">
        <input
          type="text"
          placeholder="Enter Transaction or Block ID"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      <div className="iframe-container">
        <iframe
          src={iframeSrc}
          title="Bait Coin Block Explorer"
          width="100%"
          height="800"
          style={{
            border: 'none',
            borderRadius: '10px',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
          }}
        ></iframe>
      </div>

      <div className="explorer-footer">
        <p>Stay updated with the latest Bait Coin blocks and transactions!</p>
      </div>
    </div>
  );
};

export default Explorer;
